import React, { PureComponent } from 'react';
import ErrorBoundary from '../../hocs/ErrorBoundary/ErrorBoundary';
import Slide from './Slide';
import s from './Slider.scss';
import { addEvent, removeEvent, width, height } from '../../utils/dom';

class Slider extends PureComponent {
	componentWillMount() {
		const { content, contentKey, changeSlide, windowDimensions } = this.props;
		const { startSlider } = content;

		if (typeof window !== 'undefined') {
			if (startSlider.length > 1) {
				this.interval = window.setInterval(() => {
					changeSlide(contentKey);
				}, 4000);
			}

			addEvent(window, 'resize.slider', () => {
				window.requestAnimationFrame(() => {
					windowDimensions(width(window), height(window));
				});
			});

			windowDimensions(width(window), height(window));
		}
	}

	componentWillUnmount() {
		if (typeof window !== 'undefined' && this.interval) {
			window.clearInterval(this.interval);
			removeEvent(window, 'resize.slider');
		}
	}

	render() {
		const { content, win } = this.props;
		const { startSlider, audioFile, startSliderIndex } = content;

		return (
			<div className={s.start}>
				<div className={s.slider}>
					{
						startSlider.map((slide, i) => {
							if (!slide.image) return null;
							const key = slide.image.slice(slide.image.lastIndexOf('/') + 1);
							const isActive = startSliderIndex % startSlider.length === i;
							return <ErrorBoundary message={`Key: ${key}`}><Slide {...slide} isActive={isActive} key={key} win={win} /></ErrorBoundary>;
						})
					}
				</div>
				{ audioFile ? <audio src={audioFile.url} alt={audioFile.alt} autoPlay loop /> : null }
			</div>
		);
	}
}

export default Slider;



// WEBPACK FOOTER //
// ./components/Slider/Slider.jsx